import store from "../../redux/store";
import {
  getLatitude,
  getLongitude,
  getRadius,
} from "../../redux/slices/locSlice";
import { resetProfile } from "../../redux/slices/getApiInfoSlice";
import { getSearch } from "../../redux/slices/phoneSlice";

// Shared session-cleanup used by both:
//   - axios 401 interceptor (api refused the token)
//   - ProtectedRoute JWT pre-check (token already expired, no API round trip)
//
// Keeps the two paths bit-for-bit identical so a stale token can never leak
// into redux/localStorage after either trigger fires. Synchronous: dispatches
// resolve immediately for non-async slices (which these are).
export function clearAuthSession() {
  try {
    localStorage.removeItem("token-off");
  } catch {
    /* ignore */
  }
  try {
    sessionStorage.removeItem("navigatedToOfferDetail");
  } catch {
    /* ignore */
  }
  store.dispatch(getLatitude(0));
  store.dispatch(getLongitude(0));
  store.dispatch(getRadius(40));
  store.dispatch(resetProfile());
  store.dispatch(getSearch(""));
}
